import { Constant } from '@shared/constants/index'

// 用户-教师管理
export const USER_TEACHER_TYPE = Object.freeze(
  new Constant({
    Manage: {
      label: '教师管理',
      value: 30101,
      name: 'UserTeacherManage',
    },
  }),
)

// 教师-教师管理
export const USER_MANAGE_TYPE = Object.freeze(
  new Constant({
    TeacherManage: {
      label: '教师管理',
      value: 30301,
      name: 'TeacherManage',
    },
    StudentManage: {
      label: '学生管理',
      value: 30201,
      name: 'StudentManage',
    },
  }),
)
